import React from "react";

/**
 * Use an unchanging value across renders.
 */
export const useConstant = build => {
  const ref = React.useRef();
  if (!ref.current) {
    ref.current = build();
  }
  return ref.current;
};